module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "acknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdesertshadows006#toc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I am indebted to those who contributed in various ways to this novel. The usual suspects include the stalwart Sheridan Street Irregulars: Sharon Magee, Judy Starbuck, Eileen Brady, Dan Hagey, and Charles Pyeatte for his better-than-the-author’s Spanish. Muchos gracias, mi compadres! More thanks to the ever-faithful Marge Purcell and Debra McCarthy for their tireless work. Kudos to the savvy librarians on DorothyL, whose comments on the First Amendment proved invaluable. Thanks to Dr. Deborah Mendelson for allowing me to use her name for a character, and especially for helping me describe the symptoms of water hemlock poisoning; any errors are my own. A heartfelt kiss to the rescue organization 4theLuvofDogz for Cody (who appears in these pages as Boz) and the unfailing joy my furry little friend has brought me.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("But there would be no "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("Desert Shadows")]), _vm._v(" without the incomparable Barbara Peters, Robert Rosenwald, Marilyn, Jen, Monty, Casey, and the rest of the gang down at Poisoned Pen Press who so kindly allowed me to watch a very busy publishing house in action.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081c107a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-desertshadows005.vue
// module id = 69
// module chunks = 0